module.exports = __webpack_public_path__ + "static/media/bannerEdit.e4f3a5b7.svg";